import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getCurrentLocale } from '@probatix/common/translations'
import { CORE_DOMAIN, EXPIRATION_TIME_TOKEN, TOKEN } from '@probatix/common/services/services.constants'
import LocalStorage from '@probatix/common/utils/localStorage'
import { EXPIRY_OF_JWT_TOKEN_MINUTES } from '@probatix/common/config/app'
import { saveAndUseCoreDomain } from '@probatix/common/services/services.helpers'
import { GeneratePayload } from './generateDOBTokenApiService.model'

export const ENV: string = process.env.VITE_ENV || 'local'

export const returnHeader = () => ({
  Accept: 'application/json',
  'Accept-Language': getCurrentLocale().code.slice(0, 2),
  'Content-Type': 'application/json',
})

export const returnCoreUrl = (url: string) => {
  if ('local' === ENV) {
    return `http://dev.probatix.localhost/${url}`
  }

  return `https://${LocalStorage.get(CORE_DOMAIN)}.probatix.de/${url}`
}

export const returnUrl = (coreDomain) => {
  if (coreDomain) {
    return `${saveAndUseCoreDomain(coreDomain)}myprobatix/login`
  }

  return returnCoreUrl('myprobatix/login')
}

// Define a service using a base URL and expected endpoints
export const generateDOBTokenApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: '' }),
  endpoints: (builder) => ({
    postDateOfBirthCheck: builder.mutation<
    { birthDate; coreDomain; patientEventPassword; patientEventUuid },
    GeneratePayload
    >({
      query: ({
        birthDate,
        coreDomain,
        patientEventPassword,
        patientEventUuid,
      }) => ({
        body: { birthDate, patientEventPassword, patientEventUuid },
        headers: returnHeader(),
        method: 'POST',
        url: returnUrl(coreDomain),
      }),
      transformResponse: (responseData: any) => {
        if (responseData.token) {
          const expiry = Date.now() + 1000 * 60 * Number(EXPIRY_OF_JWT_TOKEN_MINUTES)
          LocalStorage.set(EXPIRATION_TIME_TOKEN, expiry)
          LocalStorage.set(TOKEN, responseData.token)
        }

        return responseData
      },
    }),
  }),
  reducerPath: 'generateDOBTokenApi',
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const usePostGenerateDOBToken = generateDOBTokenApi.endpoints.postDateOfBirthCheck.useMutation
